// 导入所有 order 模块的国际化文件
import { messages as storeOrderCartMessages } from '@/lang/order/storeOrderCartLang.js'
import { messages as storeOrderCartReturnMessages } from '@/lang/order/storeOrderCartReturnLang.js'
import { messages as storeOrderLogisticsMessages } from '@/lang/order/storeOrderLogisticsLang.js'
import { messages as aOrderDetailMessages } from '@/lang/order/aOrderDetailLang.js'
import { messages as businessCenterMessages } from '@/lang/order/businessCenterLang.js'
import { messages as orderMessages } from '@/lang/order/orderLang.js'
import { messages as orderWriteOffConfirmMessages } from '@/lang/order/orderWriteOffConfirmLang.js'
import { messages as shopOrderMessages } from '@/lang/order/shopOrderLang.js'
import { messages as stockUpStoreOrderMessages } from '@/lang/order/stockUpStoreOrderLang.js'
import { messages as storeOrderCartFeeMessages } from '@/lang/order/storeOrderCartFeeLang.js'
import { messages as privilegeMessages } from '@/lang/order/privilegeLang.js'
import { messages as rechargeOrderMessages } from '@/lang/order/rechargeOrderLang.js'
import { messages as assistanceMoneyDetailMessages } from '@/lang/order/assistanceMoneyDetailLang.js'


// 合并所有国际化消息
export const messages = {
    en: {
        ...storeOrderCartMessages.en,
        ...storeOrderCartReturnMessages.en,
        ...storeOrderLogisticsMessages.en,
        ...aOrderDetailMessages.en,
        ...businessCenterMessages.en,
        ...orderMessages.en,
        ...orderWriteOffConfirmMessages.en,
        ...shopOrderMessages.en,
        ...stockUpStoreOrderMessages.en,
        ...storeOrderCartFeeMessages.en,
        ...privilegeMessages.en,
        ...rechargeOrderMessages.en,
        ...assistanceMoneyDetailMessages.en
    },
    zh: {
        ...storeOrderCartMessages.zh,
        ...storeOrderCartReturnMessages.zh,
        ...storeOrderLogisticsMessages.zh,
        ...aOrderDetailMessages.zh,
        ...businessCenterMessages.zh,
        ...orderMessages.zh,
        ...orderWriteOffConfirmMessages.zh,
        ...shopOrderMessages.zh,
        ...stockUpStoreOrderMessages.zh,
        ...storeOrderCartFeeMessages.zh,
        ...privilegeMessages.zh,
        ...rechargeOrderMessages.zh,
        ...assistanceMoneyDetailMessages.zh

    }
}
